import { createReducer } from 'redux-create-reducer'
import { GLOBAL_LOADER_TOGGLE } from '../../search/constants'

const initialState = {
  isShow: false,
}

export default createReducer(initialState, {
  [GLOBAL_LOADER_TOGGLE](state, { isShow }) {
    return {
      ...state,
      isShow,
    }
  },
})
